export type CatalogReportPreset = "today" | "yesterday" | "thisMonth" | "allTime" | "custom";

export interface CatalogReportDateRange {
  from?: string;
  to?: string;
}

export const CATALOG_REPORT_PRESETS: { id: CatalogReportPreset; label: string }[] = [
  { id: "today", label: "Today" },
  { id: "yesterday", label: "Yesterday" },
  { id: "thisMonth", label: "This month" },
  { id: "allTime", label: "All time" },
  { id: "custom", label: "Custom range" },
];

function startOfDay(date: Date): Date {
  const next = new Date(date);
  next.setHours(0, 0, 0, 0);
  return next;
}

function endOfDay(date: Date): Date {
  const next = new Date(date);
  next.setHours(23, 59, 59, 999);
  return next;
}

export function resolveCatalogReportRange(
  preset: CatalogReportPreset,
  customFrom?: string,
  customTo?: string
): CatalogReportDateRange {
  const now = new Date();

  if (preset === "allTime") {
    return {};
  }

  if (preset === "today") {
    return {
      from: startOfDay(now).toISOString(),
      to: endOfDay(now).toISOString(),
    };
  }

  if (preset === "yesterday") {
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    return {
      from: startOfDay(yesterday).toISOString(),
      to: endOfDay(yesterday).toISOString(),
    };
  }

  if (preset === "thisMonth") {
    const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
    return {
      from: startOfDay(monthStart).toISOString(),
      to: endOfDay(now).toISOString(),
    };
  }

  return {
    from: customFrom ? startOfDay(new Date(customFrom)).toISOString() : undefined,
    to: customTo ? endOfDay(new Date(customTo)).toISOString() : undefined,
  };
}
